<template>
  <el-dialog
      v-bind="$attrs"
      :visible.sync="visible"
      custom-class="common-dialog"
  >
    <slot></slot>
    <template v-if="$slots.footer">
      <span slot="footer">
        <slot name="footer"></slot>
      </span>
    </template>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      visible: false
    }
  },
  methods: {
    showDialog() {
      this.visible = true
    },
    closeDialog() {
      this.visible = false
    }
  }
}
</script>
<style scoped lang="scss">
/deep/ .common-dialog {
  border-radius: 8px;
  width: 720px;

  .el-dialog__header {
    height: 48px;
    line-height: 48px;
    background: #CEC298;
    border-radius: 8px 8px 0 0;
    padding: 0 0 0 20px;

    .el-dialog__title {
      font-weight: 500;
      font-size: 16px;
      color: $color-level1;
    }

    .el-dialog__close {
      color: $color-level2;
    }
  }

  .el-dialog__body {
    padding: 40px;
  }

  .el-dialog__footer {
  }
}
</style>
